var _g, _defs;

var _excluded = ["title", "titleId"];

function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

import * as React from "react";

function SvgCashIcon(_ref, svgRef) {
  var title = _ref.title,
      titleId = _ref.titleId,
      props = _objectWithoutProperties(_ref, _excluded);

  return /*#__PURE__*/React.createElement("svg", _extends({
    viewBox: "0 0 32 32",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    iconsize: 40,
    className: "Icon-sc-1iwi4w1-0 ggQRJq",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    clipPath: "url(#cash_svg__clip0)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M24.024 13.609v5.02l3.177-1.204L23.17 7.33a1 1 0 00-1.3-.558L4.8 13.61",
    fill: "#56BB8A"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M4.8 13.456h21.4a1 1 0 011 1v10.41a1 1 0 01-1 1H5.8a1 1 0 01-1-1v-11.41z",
    fill: "#56BB8A"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M6.047 17.886c1.325-.28 2.362-1.012 2.758-1.948H23.2c.396.936 1.433 1.668 2.758 1.948v3.55c-1.325.28-2.362 1.012-2.758 1.948H8.805c-.397-.936-1.433-1.668-2.758-1.948v-3.55z",
    fill: "#91E5BD"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M15.802 21.824a2.285 2.285 0 002.289-2.282 2.285 2.285 0 00-2.289-2.282 2.285 2.285 0 00-2.288 2.282 2.285 2.285 0 002.288 2.282z",
    fill: "#56BB8A"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M23.71 13.608l-1.086-2.784-.05-.122a3.215 3.215 0 01-2.8-1.201l-.122.049-9.814 4.058h13.871z",
    fill: "#91E5BD"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M10.624 19.999a.457.457 0 100-.914.457.457 0 000 .914zM20.692 19.999a.457.457 0 10.001-.914.457.457 0 000 .914z",
    fill: "#56BB8A"
  }))), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("clipPath", {
    id: "cash_svg__clip0"
  }, /*#__PURE__*/React.createElement("path", {
    fill: "#fff",
    d: "M0 0h32v32H0z"
  })))));
}

var ForwardRef = /*#__PURE__*/React.forwardRef(SvgCashIcon);
export default __webpack_public_path__ + "static/media/CashIcon.8b2666afa4f2d2fb4eb8840fc45474cd.svg";
export { ForwardRef as ReactComponent };